import { render } from "./TestimonioRewardNew.vue?vue&type=template&id=d1918586&scoped=true"
import script from "./TestimonioRewardNew.vue?vue&type=script&lang=js"
export * from "./TestimonioRewardNew.vue?vue&type=script&lang=js"

import "./TestimonioRewardNew.vue?vue&type=style&index=0&id=d1918586&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1918586"]])

export default __exports__